module.exports = __webpack_public_path__ + "static/media/scroll3_5_3.ca590815.png";